import {URL} from '../constants';
import axios from 'axios';

const getMainCategories = () => {
  return getRequest(URL + `/MiscibleProducts/GetMainCategorys`);
}

const subCategoryFromMain = (id) => {
  return getRequest(URL + '/MiscibleProducts/GetSubCategorys?MainCategoryID=' + id);
}

const preparationsFromSubcategory = (id) => {
  return getRequest(URL + '/MiscibleProducts/GetProducts?SubCategoryID=' + id);
}

const subcategoriesForPreparation = (id) => {
  return getRequest(URL + '/MiscibleProducts/GetSubCategorysIsMisciblewithThisProducts?ProductID=' + id);
}

const getMixingGuide = (preparationId,subCategoryId) => {
  return getRequest(URL + '/MiscibleProducts/GetProductIsMisciblewithThisProductsAndSubCategoryID?ProductID=' + preparationId + "&SubCategoryID=" + subCategoryId);
}

const getRequest = async (url) => {

  try{
    let response = await axios.get(url);
    if (response.status < 200 || response.status >= 300) {
         throw new Error(response.statusText);
    }
    return response.data;

   }catch(e){
     console.log(e);
     return Promise.reject(e);
   }
}

export {getMainCategories,subCategoryFromMain,preparationsFromSubcategory,subcategoriesForPreparation,getMixingGuide};
